export default {
    formatNotes(options: any) {
        const notesMultiLines = options?.notesMultiLines || false;
        const notesLimit = options?.notesLimit || 256;
        let notesValue = options?.notesValue || '';

        let notesError = false;

        if (!notesMultiLines) {
            notesValue = notesValue.replace(/[\n\r]+/g, ' '); // remove newlines
        }

        // strip out HTML tags from a string
        const div = document.createElement('div');
        div.innerHTML = notesValue.toString();
        notesValue = div.textContent || div.innerText || '';

        notesValue = notesValue.replace(/ +(?= )/g, ''); // remove multiple spaces

        if (notesValue.length > notesLimit) {
            notesError = true;
        } else {
            notesError = false;
        }

        return {
            notesError: notesError,
            notesValue: notesValue,
            notesCount: notesValue.length
        };
    }
};
